<template lang="pug">
  div(class="root coment-container")
    div(class="commentcontainer")
      input(v-model.trim="ui.inputComment", placeholder="コメント入力欄", class="coment-erea")
      div(class="commentcontainer-button")
        button(:disabled="!isStarted" @click="onCommentSend()" class="send-button")
        button(:disabled="!isStarted" @click="onHide()" class="hide-button")
</template>

<style src="./Comment.scss" lang="scss" scoped>

</style>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: "LiveComponentComment",
  components: {},
  data() {
    return {
      ui: {
        inputComment: ''
      },
      initSuccess: false,
    }
  },
  props: {},
  computed: {
    isStarted(){
      return this.$store.getters.enum_list.live_status_list.ONGOING == this.$store.state.live.info.status || this.$store.getters.enum_list.live_status_list.PREPARATION == this.$store.state.live.info.status;
    },
  },
  watch: {},
  mounted() {},
  async created() {
  },
  updated() {},
  async beforeDestroy() {
    if (this.initSuccess) {
      // TIM
      await this.$store.dispatch('live/timLogout');

    }
  },
  methods: {
    async init() {
      // TIM
      try{ 
        await this.$store.dispatch('live/timInit');
        this.$nextTick(() => {
          VueScrollTo.scrollTo('#comment-list-last', 100, {
            container: '#comment-list-root',
          })
        })
        await this.$store.dispatch('live/timLogin');
        await this.$store.dispatch('live/timJoinGroup');
      } catch(e) {
        console.log('TIM Init Failed');
        console.log(this.$store.state.live.commentList)
        console.log(e);
      }

      this.initSuccess = true;
    },
    
    async onCommentSend() {
      if (!this.ui.inputComment || !this.$store.state.live.info.id) {
        return;
      }
      await this.$store.dispatch('live/timSendMessagePlain', {
        text: this.ui.inputComment
      });
      this.ui.inputComment = '';
    },
    async onHide() {
      // if (!this.ui.inputComment || !this.$store.state.live.info.id) {
      //   return;
      // }
      await this.$store.dispatch('live/timSendMessagePlain', {
        text: "",
      });
      this.ui.inputComment = '';
    }
  }
};
</script>
